import React from "react";
import { MemberSecureCard } from "@icoach/components";
import { Box, Chip, Typography } from "@curves/ui-base";
import { orderStatusColorMap } from "@icoach/accountBook/staticData";
import { formatCurrencyFn } from "@util/utils";

export const getBillingACHRowsLabel = () => [
	{
		cellKey: "memberSheet",
		headerLabel: "會員",
		align: "left",
		maxWidth: 20.4,
		formatCell: (_v, { displayName, maskDisplayName, memberNo, memberPicturePath }, { isRevealed }) => {
			return <MemberSecureCard name={displayName} maskName={maskDisplayName} avatar={memberPicturePath} memberNo={memberNo} isRevealed={isRevealed} />;
		},
	},
	{
		cellKey: "transactionStatusText",
		headerLabel: "交易狀態",
		align: "center",
		formatCell: (cellValue, { transactionStatus = 0 }) => {
			return <Chip label={cellValue} color={orderStatusColorMap.get(transactionStatus)} />;
		},
	},
	{
		cellKey: "transactionTypeText",
		headerLabel: "交易類型",
		align: "center",
	},
	{
		cellKey: "itemName",
		headerLabel: "品項",
		align: "center",
	},
	{
		cellKey: "transactionPrice",
		headerLabel: "交易金額",
		align: "center",
		formatCell: cellValue => {
			return formatCurrencyFn(cellValue);
		},
	},
	{
		cellKey: "bankAccount",
		headerLabel: "銀行帳號",
		maxWidth: 21,
		formatCell: (cellValue, { bankCode, bankName }) => {
			return (
				<Box className="payment-card-content">
					{bankName && (
						<Typography className={"sub-title font-color-3 mb-0"} variant={"body1"}>
							{bankName}
						</Typography>
					)}
					<Typography className={"title font-color-3 mb-0"} variant={"body1"}>
						代號：{bankCode}
					</Typography>
					<Typography className={"title mb-0"} variant={"body1"} component={"h6"}>
						{cellValue}
					</Typography>
				</Box>
			);
		},
	},
	{
		cellKey: "note",
		headerLabel: "備註",
		maxWidth: 30,
	},
];
